import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const sessionId = location.state?.sessionId || new URLSearchParams(location.search).get('credit_session');

  useEffect(() => {
    if (!sessionId) {
      navigate('/');
    }
  }, [sessionId, navigate]);

  const handlePayment = async () => {
    setLoading(true);
    try {
      const originUrl = window.location.origin;
      
      const response = await axios.post(`${API}/checkout/session`, {
        session_id: sessionId,
        origin_url: originUrl
      });

      if (response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error('Payment error:', error);
      alert('Failed to initiate payment. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="preview-container">
      <div className="preview-content" style={{ maxWidth: 600 }}>
        <h1 className="preview-title" data-testid="payment-title">Unlock Your Credit Plan</h1>

        <div className="unlock-section" style={{ marginTop: 0 }}>
          <div className="unlock-price" data-testid="payment-price">$29</div>
          <div style={{ fontSize: 14, color: '#475569', marginBottom: 24 }}>One-time payment • Instant access</div>
          
          <div style={{ textAlign: 'left', marginBottom: 32, color: '#334155' }}>
            <div style={{ marginBottom: 12, fontWeight: 600, fontSize: 16 }}>What's Included:</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <span style={{ color: '#10b981', fontSize: 20 }}>✓</span>
              <span>Complete step-by-step credit action plan</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <span style={{ color: '#10b981', fontSize: 20 }}>✓</span>
              <span>Priority-ranked actions (what to do first)</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <span style={{ color: '#10b981', fontSize: 20 }}>✓</span>
              <span>Timeline-based strategy for your goal</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <span style={{ color: '#10b981', fontSize: 20 }}>✓</span>
              <span>Score projection and progress tracking</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ color: '#10b981', fontSize: 20 }}>✓</span>
              <span>Instant access • No subscription</span>
            </div>
          </div>

          <button 
            data-testid="proceed-to-payment-btn"
            className="unlock-btn" 
            onClick={handlePayment}
            disabled={loading}
            style={{ width: '100%' }}
          >
            {loading ? 'Processing...' : 'Proceed to Payment'}
          </button>
          
          <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 16 }}>
            Secure payment powered by Stripe
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
